import React from "react";
import { formatToDate } from "../../master/FormatToDateTime";
import { followupAdd } from "../../../api/FollowUps";
import { closeModal, SweetAlertShow } from "../../master/Master";
import usePrivateLink from "../../config/usePrivateLink";

export default function FollowUpModal({ data, setLoading, handleFunction }) {
  const hasAccess = usePrivateLink();

  const handleAdd = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const formData = new FormData(e.target);
      const response = await followupAdd(formData);
      if (response?.data?.status) {
        closeModal("AddNewFollowup");
        e?.target?.reset();
        SweetAlertShow("success", "Successfully", response?.data?.message);
      } else {
        SweetAlertShow("info", "warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
        error?.response?.message ??
        error?.message
      );
    } finally {
      setLoading(false);
      handleFunction();
    }
  };
  return (
    <>
      <div
        className="modal fade"
        id="AddNewFollowup"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <form action="" onSubmit={handleAdd}>
              <div className="modal-header py-3 bg-label-primary">
                {hasAccess("/enquiry/followups/add") && (
                  <h1 className="modal-title fs-5" id="exampleModalLabel">
                    New Followup
                  </h1>
                )}
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />

              </div>
              <div className="modal-body">
                <div className="row g-5">
                  <div className="col-12 border rounded-3 p-3">
                    <h6 className="text-primary">Last Followups</h6>

                    <div
                      className="w-100 overflow-auto"
                      style={{ height: "35vh" }}
                    >
                      <ul className="timeline list-unstyled">
                        {data?.followups?.map((item, index) => (
                          <li
                            key={item.id}
                            className="mb-4 position-relative ps-4"
                          >
                            <span className="timeline-dot bg-primary"></span>

                            <h6 className="fw-bold mb-1">
                              Follow-up #{data?.followups?.length + 1 - index}
                            </h6>

                            <p className="mb-1">
                              <strong>Response:</strong> {item.response}
                            </p>

                            <p className="text-muted mb-0">
                              <strong>Follow-Up:</strong>{" "}
                              {formatToDate(item.followup_date)}
                            </p>
                          </li>
                        ))}

                        <li className="mb-2 position-relative ps-4">
                          <span className="timeline-dot bg-secondary"></span>

                          <h6 className="fw-bold mb-1">Follow-up #1</h6>

                          <p className="mb-1">
                            <strong>Reference Detail:</strong>{" "}
                            {data?.reference_detail}
                          </p>
                          <p className="mb-1">
                            <strong>Note:</strong> {data?.note}
                          </p>

                          <p className="text-muted mb-0">
                            <strong>Enquiry Date:</strong>{" "}
                            {formatToDate(data.enquiry_date)}
                          </p>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <input type="hidden" name="user_id" value={data?.id} />
                  <input type="hidden" name="type" value="enquiry" />
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <textarea
                        className="form-control input-uppercase"
                        name="response"
                        placeholder="Response"
                        required
                      />
                      <label>
                        Response <sup className="text-danger">*</sup>
                      </label>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="date"
                        className="form-control"
                        name="next_followup_date"
                        required
                        defaultValue={new Date().toISOString().split("T")[0]}
                      />
                      <label>
                        Next FollowUp Date <sup className="text-danger">*</sup>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer py-3 bg-label-primary">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button type="submit" className="btn btn-primary">
                  Save changes
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
